import React from 'react';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Legend,
} from 'recharts';

interface RadarData {
  dimension: string;
  score: number;
  fullMark?: number;
}

interface CompetitiveRadarChartProps {
  data: RadarData[];
  companyName?: string;
}

export const CompetitiveRadarChart: React.FC<CompetitiveRadarChartProps> = ({
  data,
  companyName,
}) => {
  // Ensure we have all 5 dimensions
  const dimensions = [
    'Strategic Planning',
    'Organizational Leadership',
    'Communication Skills',
    'External Adaptability',
    'Innovation Capability',
  ];

  const chartData = dimensions.map((dim) => {
    const existing = data.find((d) => d.dimension === dim);
    return {
      dimension: dim,
      score: existing?.score || 0,
      fullMark: 100,
    };
  });

  return (
    <div className="w-full">
      {companyName && (
        <h3 className="sub-header text-xl mb-4">
          Competitive Analysis: {companyName}
        </h3>
      )}
      <ResponsiveContainer width="100%" height={400}>
        <RadarChart data={chartData}>
          <PolarGrid />
          <PolarAngleAxis
            dataKey="dimension"
            tick={{ fontSize: 12, fill: '#666' }}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 100]}
            tick={{ fontSize: 10, fill: '#999' }}
          />
          <Radar
            name="Score"
            dataKey="score"
            stroke="#76B900"
            fill="#76B900"
            fillOpacity={0.6}
          />
          <Legend />
        </RadarChart>
      </ResponsiveContainer>
      <div className="mt-4 grid grid-cols-2 md:grid-cols-5 gap-4">
        {chartData.map((item) => (
          <div key={item.dimension} className="text-center">
            <p className="body-text text-sm text-gray-600 mb-1">
              {item.dimension}
            </p>
            <p className="sub-header text-lg text-blazerex-green">
              {item.score}/100
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

